import { taskAPI } from '@/utils/api';
import { releaseIpeProcessingSlot } from '@/utils/ipeProcessingQueue';

/**
 * 终止服务端批处理 Worker（与列表页「终止任务」配合）。
 * 无论 cancel API 是否成功，都尝试释放 Redis 处理槽，避免僵尸占满单用户配额。
 */
export async function cancelIpeServerBatch(taskId) {
  const id = taskId == null ? '' : String(taskId).trim();
  if (!id) return;
  try {
    await taskAPI.cancelBatch(id);
  } catch (error) {
    console.warn('[批处理] 服务端任务取消失败:', error);
  }
  await releaseIpeProcessingSlot(id);
}
